@if (layout.HeaderLayout.ShowLogo && layout.Logo && layout.Logo.SvgLogo) {
  <a
    [routerLink]="'/'"
    class="logo-link svg-logo logo-desktop"
    [class.has-mobile-logo]="hasSmallLogo()"
    [innerHTML]="layout.Logo.SvgLogo | sanitizeHtml"
    aria-label="hem"
  ></a>
}
@if (
  layout.HeaderLayout.ShowLogo &&
  layout.Logo &&
  layout.Logo.Image &&
  layout.Logo.Image.Url &&
  !layout.Logo.SvgLogo
) {
  <a
    [routerLink]="'/'"
    class="logo-link image-logo logo-desktop"
    [class.has-mobile-logo]="hasSmallLogo()"
    aria-label="hem"
  >
    <img
      [ngSrc]="
        layout.Logo.Image.Url
          | image: 500 : layout.Logo.Image : 'fit' : height : true
      "
      [width]="layout.Logo.Image | imageWidth: height"
      [height]="height"
      [alt]="pageName"
      priority
    />
  </a>
}
@if (layout.HeaderLayout.ShowLogo && layout.Logo && layout.Logo.SvgLogoSmall) {
  <a
    [routerLink]="'/'"
    class="logo-link svg-logo logo-mobile"
    [innerHTML]="layout.Logo.SvgLogoSmall | sanitizeHtml"
    aria-label="hem"
  ></a>
}
@if (
  layout.HeaderLayout.ShowLogo &&
  layout.Logo &&
  layout.Logo.ImageSmall &&
  layout.Logo.ImageSmall.Url &&
  !layout.Logo.SvgLogoSmall
) {
  <a [routerLink]="'/'" class="logo-link image-logo logo-mobile" aria-label="hem">
    <img
      [ngSrc]="
        layout.Logo.ImageSmall.Url
          | image: 500 : layout.Logo.ImageSmall : 'fit' : height : true
      "
      [width]="layout.Logo.ImageSmall | imageWidth: height"
      [height]="height"
      [alt]="pageName"
      priority
    />
  </a>
}
